/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Action_MerchandiseInputs */

const en_footer_action_merchandise = /** @type {(inputs: Footer_Action_MerchandiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merchandise`)
};

/**
* | output |
* | --- |
* | "Merchandise" |
*
* @param {Footer_Action_MerchandiseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_action_merchandise = /** @type {((inputs?: Footer_Action_MerchandiseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Action_MerchandiseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_action_merchandise(inputs)
});